import { render, staticRenderFns } from "./dialog-card.vue?vue&type=template&id=2a1906a4&"
import script from "./dialog-card.vue?vue&type=script&lang=js&"
export * from "./dialog-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports